import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { LeadForm } from '../components/LeadForm';
import { WhatsAppIcon } from '../components/icons/WhatsAppIcon';
import { ServiceAreaSection } from '../components/home/ServiceAreaSection';
import { business, businessHours } from '../data/site';
import { useLanguage } from '../contexts/LanguageContext';
import { useSeo } from '../hooks/useSeo';
export function Contact() {
  const {
    t,
    lang
  } = useLanguage();
  useSeo({
    title: lang === 'en' ? 'Contact M&S Multiservices | Free Estimates in Dallas TX' : 'Contacta a M&S Multiservices | Presupuestos Gratis en Dallas TX',
    description: lang === 'en' ? 'Request a free estimate for painting, drywall, flooring or remodeling in Dallas-Fort Worth. Call or WhatsApp +1 (214) 259-5582, or send us your project details.' : 'Solicita un presupuesto gratis de pintura, drywall, pisos o remodelación en Dallas-Fort Worth. Llama o escribe por WhatsApp al +1 (214) 259-5582.'
  });
  return <>
      <PageHeader eyebrow={t({
      en: 'Contact',
      es: 'Contacto'
    })} title={t({
      en: 'Get your free estimate',
      es: 'Obtén tu presupuesto gratis'
    })} description={t({
      en: 'Call, WhatsApp or send the form — whichever is easiest. We answer in English or Spanish and schedule most estimate visits within 24 to 48 hours.',
      es: 'Llama, escribe por WhatsApp o envía el formulario — lo que te sea más fácil. Respondemos en inglés o español y agendamos la mayoría de visitas en 24 a 48 horas.'
    })} showActions={false} data-id="element-397" data-mp="19fz2p4mrpkuw" />

      <section className="bg-white" data-id="element-398" data-mp="10h58tm0tn8l1">
        <div className="mx-auto max-w-7xl px-6 py-16 sm:py-20" data-id="element-399" data-mp="10dzik3ggi0nq">
          <div className="grid gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16" data-id="element-400" data-mp="26vmpyjvhtiht">
            <div data-id="element-401" data-mp="2bupqps4fx2jz">
              <h2 className="font-display text-2xl text-navy" data-id="element-402" data-mp="2bu7rqnqe8a8d">
                {t({
                en: 'Talk to us directly',
                es: 'Habla con nosotros directamente'
              })}
              </h2>
              <ul className="mt-6 space-y-3" data-id="element-403" data-mp="1h92316g3zaz9">
                <li data-id="element-404" data-mp="1had5n2xticos">
                  <a href={business.phoneHref} className="flex items-center gap-4 rounded-lg border border-navy/10 p-4 transition-colors duration-150 ease-out-expo hover:border-gold hover:bg-gold-50" data-id="element-405" data-mp="1w5jbnpwwybi4">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy" data-id="element-406" data-mp="13hdpcyq7oeg6">
                      <PhoneIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-407" data-mp="yjlx23lnmqbg" />
                    </span>
                    <span data-id="element-408" data-mp="1d8i5w2vjc7d4">
                      <span className="block text-sm text-ink/60" data-id="element-409" data-mp="18g8gqp28vbbw">
                        {t({
                        en: 'Call or text',
                        es: 'Llama o envía mensaje'
                      })}
                      </span>
                      <span className="block font-semibold text-navy" data-id="element-410" data-mp="ko1i1j91qs9b">
                        {business.phoneDisplay}
                      </span>
                    </span>
                  </a>
                </li>
                <li data-id="element-411" data-mp="2w53cho5apqfd">
                  <a href={business.whatsappHref} target="_blank" rel="noreferrer" className="flex items-center gap-4 rounded-lg border border-navy/10 p-4 transition-colors duration-150 ease-out-expo hover:border-gold hover:bg-gold-50" data-id="element-412" data-mp="2w5ms2y7h42q8">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#25D366]" data-id="element-413" data-mp="3a5xkw6scfre1">
                      <WhatsAppIcon className="h-5 w-5 text-[#0B3B22]" data-id="element-414" data-mp="3f1v4clywldv1" />
                    </span>
                    <span data-id="element-415" data-mp="316snj3siq43g">
                      <span className="block text-sm text-ink/60" data-id="element-416" data-mp="355ia9mzg4xzr">WhatsApp</span>
                      <span className="block font-semibold text-navy" data-id="element-417" data-mp="1ppauay8kcmv6">
                        {business.phoneDisplay}
                      </span>
                    </span>
                  </a>
                </li>
                <li data-id="element-418" data-mp="29yj0trj7p097">
                  <a href={business.emailHref} className="flex items-center gap-4 rounded-lg border border-navy/10 p-4 transition-colors duration-150 ease-out-expo hover:border-gold hover:bg-gold-50" data-id="element-419" data-mp="29z2ir88v3on8">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-420" data-mp="1v94s8lngmmuv">
                      <MailIcon className="h-5 w-5 text-navy-deep" aria-hidden="true" data-id="element-421" data-mp="2swn0zwh4foyv" />
                    </span>
                    <span className="min-w-0" data-id="element-422" data-mp="2nxir13mdhn7h">
                      <span className="block text-sm text-ink/60" data-id="element-423" data-mp="2nvpghd8n2iu7">Email</span>
                      <span className="block break-all font-semibold text-navy" data-id="element-424" data-mp="2ix4ep9dqnr3n">
                        {business.email}
                      </span>
                    </span>
                  </a>
                </li>
              </ul>

              <div className="mt-8 rounded-lg bg-mist p-6" data-id="element-425" data-mp="13hylhmd8hqwm">
                <h3 className="flex items-center gap-2 font-display text-lg text-navy" data-id="element-426" data-mp="13gdrbxuu09za">
                  <ClockIcon className="h-5 w-5 text-gold-dark" aria-hidden="true" data-id="element-427" data-mp="3f6lkeorcqwq7" />
                  {t({
                  en: 'Business hours',
                  es: 'Horario de atención'
                })}
                </h3>
                <dl className="mt-4 space-y-2 text-sm" data-id="element-428" data-mp="3o5qhrrr6gk0s">
                  {businessHours.map(entry => <div key={entry.day.en} className="flex justify-between gap-4" data-id="element-429" data-mp="3sxqoc31r6b6c">
                      <dt className="text-ink/70" data-id="element-430" data-mp="1qxgwhgd9ftd">{t(entry.day)}</dt>
                      <dd className="text-right font-medium text-navy" data-id="element-431" data-mp="1sqoq02pu62y">{t(entry.hours)}</dd>
                    </div>)}
                </dl>
                <p className="mt-5 flex items-start gap-2 border-t border-navy/10 pt-4 text-sm text-ink/70" data-id="element-432" data-mp="asdnsf7z2zsu">
                  <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-433" data-mp="fpndlvz9xdh7" />
                  {t({
                  en: 'Based in Dallas, Texas. Serving the entire Dallas-Fort Worth Metroplex and surrounding areas.',
                  es: 'Con base en Dallas, Texas. Atendemos todo el Metroplex de Dallas-Fort Worth y áreas cercanas.'
                })}
                </p>
              </div>
            </div>

            <LeadForm data-id="element-434" data-mp="3tsvy73lenws4" />
          </div>
        </div>
      </section>

      <ServiceAreaSection data-id="element-435" data-mp="3tr18zd33pii8" />
    </>;
}